module.exports = __webpack_public_path__ + "static/img/topleft.77912eac.png";